import axios from "axios";

export default {
  name: "service",
  props: {},
  data() {
    return {
      token: JSON.parse(localStorage.getItem("md5")),
      ESTADOS: {
        BORRADOR: {
          key: 'BORRADOR',
          nombre: 'Borrador',
          color: '#f1c40f',
        },
        ESPERANDO_APROBACION: {
          key: 'ESPERANDO_APROBACION',
          nombre: 'Esperando Aprobación',
          color: '#8e44ad',
        },
        REVISION: {
          key: 'REVISION',
          nombre: 'Necesita Revisión',
          color: '#e67e22',
        },
        ENVIADO: {
          key: 'ENVIADO',
          nombre: 'Enviado',
          color: '#27ae60',
        },
        CANCELADO: {
          key: 'CANCELADO',
          nombre: 'Cancelado',
          color: '#c0392b',
        },
        PROGRAMADO: {
          key: 'PROGRAMADO',
          nombre: 'Programado',
          color: '#2980b9',
        },
        AB_PROGRAMADO: {
          key: 'AB_PROGRAMADO',
          nombre: 'AB programado',
          color: '#089a86',
        },
        ABTESTING: {
          key: 'ABTESTING',
          nombre: 'AB en ejecución',
          color: '#badcfd',
        },
      },
      PAISES: [],
      CATEGORIAS: [],
      endPoint: process.env.VUE_APP_API_ENDPOINT
    };
  },
  methods: {
    async sendRequest(obj) {
      const defaults = {
        url: null,
        method: "post",
        data: [],
        sendFile: false,
        headers: {
          _md5: this.token,
          "Content-Type": obj.sendFile ? "multipart/form-data" : undefined,
        },
      };
      let opciones = { ...defaults, ...obj };
      const response = await axios({
        method: opciones.method,
        url: `${this.endPoint}${opciones.url}`,
        data:
          opciones.method.toLowerCase() === "get" ? undefined : opciones.data,
        headers: opciones.headers,
      }).catch(function(error) {
        this.$message.error(error)
      });
      if(response.data.code && response.data.code !== 200) {
        this.$message.error(response.data.message)
      }
      return response.data;
    },
    nFormatter(num, digits) {
      const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" }
      ];
      const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
      let item = lookup.slice().reverse().find(function(item) {
        return num >= item.value;
      });
      return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
    },
    format_number(num){
      if(!isNaN(num)){
        num = parseInt(num);

        if(num >= 1000000) {
          return this.nFormatter(num, 2)
        }


        return new Intl.NumberFormat().format(num);
      }else
        return '-'
    },
  },

};
